import React from 'react';
//import textos from "../data/textos.json";
import dsPdfs from "../data/pdf.json";
import textosJson from "../data/textos.json";
import assets from '../data/config/config.json';
import apLinks from "../data/links.json";
var links = apLinks[0];
const audio = assets.audio;
const img = assets.img.apoyosPlan;
const imgGenerales = assets.img.general;
const enlaceCurricular = assets.img.apoyosPlan;
const textos = textosJson[0];
var pdfs = dsPdfs[0];
//var links = dsLinks[0];


const reproducirSonido = () => {
    console.log("Audio");

    var tmpAudio = document.getElementById("planeamiento");
    tmpAudio.currentTime = 0;
    tmpAudio.play();
}


const Planeamiento = (props) => {
    return (
        <div>
            <div className="row">
                <div className="col-5">
                    <img tabIndex="1" role="banner" className="titulos img-fluid" src={img + "titulo.png"} alt="Banner de apoyos para el planeamiento" />
                    <img id="imgFondoDescripcion" onClick={reproducirSonido} onKeyPress={reproducirSonido} className="descripciones3 img-fluid" src={imgGenerales + "caja_descripcion.png"} alt="Descripción de la sección de apoyos para el planeamiento" />
                    <div tabIndex="2" onKeyPress={reproducirSonido} onClick={reproducirSonido} id="textoDescripcion" className="texto_descripciones text-justify pr-3">
                        <h2 className='desc'>Descripción:</h2>  {props.infoCategory}
                    </div>
                </div>


                <div className="col-7">
                    <div className="row">
                        <div className="botones_salir col-12">
                            <img tabIndex="5" role="button" data-tar="Home" onClick={props.changePage} onKeyPress={props.changePage} className="derecha btn img-fluid hvr-pop" src={imgGenerales + "btn_salir.png"} alt="regresar a portada" />
                        </div>
                    </div>



                    <div id="botones-planeamiento" className="row">

                      
                            <div className="col-12 text-center contenedor">
                                <img
                                    alt="Enlace"
                                    tabIndex="3"

                                    className="img-fluid"
                                    src={enlaceCurricular + "imagenEnlace.jpg"}
                                />
                                {/* <p> La documentación vigente para el curso lectivo 2023, está disponible en el siguiente enlace:</p> */}
                                <div id="enlaceCurricular" class="centrado"><a href="https://ddc.mep.go.cr/documentos" target="_blank">Dirección de Desarrollo Curricular ⇒</a></div>

                            </div>
                      

                    </div>
                </div>
            </div>
            <br /><br />
            <audio src={audio + "apoyos_plan.mp3"} id="planeamiento" preload="true"  ></audio>

        </div>
    );
}

export default Planeamiento;